import { Address } from "@core/types";
import { AddressInputWithId } from "../providers/customerAddressesStorage";

export const getAddressByIdBasedOnAuthStatus = (
  isUserAuthenticated: boolean,
  addressId: Address["id"] | AddressInputWithId["id"],
  customerAddresses: Address[],
  unAuthedCustomerAddresses: AddressInputWithId[],
): Address | null => {
  const addresses: Address[] = isUserAuthenticated ? customerAddresses : unAuthedCustomerAddresses;
  const customerAddress = addresses.find((address) => address.id === addressId)!;

  return customerAddress ?? null;
};
